// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"151":"Test","274":"Home"}[chunkId] + "." + {"151":"e26220f3","274":"4f034e44"}[chunkId] + ".css";
};